import classNames from 'classnames';
import type { CSSProperties, FC, ReactNode } from 'react';

interface Props {
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}

const ErrorMessage: FC<Props> = (props) => (
  <span
    className={classNames(props.className, 'text-red-500')}
    style={props.style}
  >
    {props.children}
  </span>
);

export default ErrorMessage;
